function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 .5c.277 0 .5.224.5.5v3c0 .133-.052.26-.146.354l-.854.853V6.5c0 .245-.176.45-.41.492L23 7h-1.293l-.207.207V8.5c0 .245-.176.45-.41.492L21 9h-1.293l-.207.207V10.5c0 .245-.176.45-.41.492L19 11h-1.293l-2.885 2.885.082.182c1.143 2.689.625 5.841-1.4 8.027l-.2.208c-2.93 2.93-7.678 2.93-10.607 0-2.93-2.929-2.93-7.677 0-10.606 2.19-2.19 5.46-2.78 8.237-1.6l.181.082L20.647.646c.075-.075.171-.123.275-.14L21 .5zm-.5 1h-2.293l-9.635 9.637c-.132.132-.324.177-.498.125l-.085-.035c-2.495-1.292-5.568-.84-7.585 1.177-2.539 2.537-2.539 6.653 0 9.192 2.539 2.54 6.654 2.54 9.193 0 2.016-2.017 2.468-5.09 1.177-7.583-.1-.193-.064-.43.09-.584l3.283-3.283c.094-.093.22-.146.354-.146h.999V9c0-.106.034-.209.096-.294l.05-.06.5-.5c.095-.093.222-.146.354-.146h1V7c0-.106.034-.209.096-.294l.05-.06.5-.5c.095-.093.222-.146.354-.146h1V5c0-.106.034-.209.096-.294l.05-.06.854-.854V1.5zM6 17c1.105 0 2 .896 2 2 0 1.105-.895 2-2 2-1.104 0-2-.895-2-2 0-1.104.896-2 2-2zm0 1c-.551 0-1 .448-1 1s.448 1 1 1c.553 0 1-.448 1-1s-.448-1-1-1z",
  transform: "translate(1 1) translate(-1 -1)"
});

var SvgKey = function SvgKey(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: props.color
  }, _ref2)));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/key.a159fe8c.svg";
export { ForwardRef as ReactComponent };